import { Field, ErrorMessage } from 'formik' 
import { AiOutlineExclamationCircle } from "react-icons/ai";

const PasswordInput = ({ errors, touched, isSignUp }) => {
  return (
    <>
        <label htmlFor='password'>{isSignUp ? "Create" : "Enter"} password</label>
        <Field 
            name="password"
            type="password"
            placeholder="••••••••••••"
            className={errors.password && touched.password ? "input-error" : ""}
        />
        <ErrorMessage name="password">
            {msg => (
                <p className="error-msg">
                    <AiOutlineExclamationCircle />
                    <span>{msg}</span>
                </p>
            )}
        </ErrorMessage>
    </>
  )
}

export default PasswordInput